import React, { VFC } from 'react';

import { ButtonProps } from './types';

const Button: VFC<ButtonProps> = ({ disabled, onClick, title }) => {
  return (
    <button
      className="btn btn-block btn-primary btn-lg"
      disabled={disabled}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default Button;
